import { createFileRoute } from '@tanstack/react-router';

import { TutorUsageTemplate } from '@/features/tutor-ai';

export const Route = createFileRoute('/_authenticated/tutor-ai/usage/')({
  component: AiUsagePage,
});

/**
 * Página do dashboard de uso e custos do assistente de IA — visão consolidada da
 * plataforma, somente leitura. Toda a orquestração de filtros e dados fica no template.
 */
export function AiUsagePage() {
  return <TutorUsageTemplate />;
}
